import axios from 'axios';
import { useEffect, useState } from 'react';
import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';

const JobNumber = ({
  isView,
  dailyProductionDate,
  process,
  setRender,
  machineId,
}: {
  dailyProductionDate: any;
  process: any;
  isView?: any;
  setRender: any;
  machineId: any;
}) => {
  const [planningData, setJobNumbers] = useState([]);
  useEffect(() => {
    if (machineId) {
      axios
        .get(
          `/api/dailyProductionRivetPlanning/getPlanningForDailyProduction?machineId=${machineId}`,
        )
        .then((res) => {
          if (res.data) {
            setJobNumbers(res.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      process.job_id = null;
      setJobNumbers([]);
    }
  }, [machineId]);
  return (
    <>
      <div>
        <AutocompleteMuiCustom
          id="jobs"
          label=""
          option_name="job_number"
          arrayofObj={planningData || []}
          value={process?.job_id || ''}
          onChange={(e, value) => {
            process.job_id = value;
            setRender((prev: any) => !prev);
          }}
        />
      </div>
    </>
  );
};
export default JobNumber;
